import React from "react";
import Photo from "./Photo";
import photos from "../../data/photography.json";

const find = (slug) => photos.find((p) => p.slug === slug);

// Editorial image-led showcase — asymmetric, layered, with a single hero caption.
// Now uses the brightest new hero (Gulab Jamun macro) as primary.
export const PhotoShowcase = ({
  eyebrow = "Selected Work — Hospitality clients · 2024 / 2025",
  title = "A quiet kind of hunger",
  body = "Cinematic plates, ambient venue, and brand campaigns shot on location across Melbourne. Two recent menu shoots — Dosa Hut Clayton and Laddu Gopal — sample below.",
}) => {
  const hero = find("hero-gulab-jamun-00") || find("hero-raj-kachori-08");
  const venue = find("hero-spread-01") || find("hero-banquet-01");
  const detail = find("menu-laddu-220") || find("detail-04");

  return (
    <section data-testid="photo-showcase" className="relative">
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-12 md:col-span-5 md:row-span-2">
          <Photo
            slug={hero?.slug}
            alt="Hero plate"
            ratio="3/4"
            caption="Hero · Plate"
            sizes="(min-width: 1024px) 40vw, 100vw"
          />
        </div>

        <div className="col-span-12 md:col-span-7 flex flex-col justify-end pb-6">
          <p className="font-mono text-[10px] uppercase tracking-wider3 text-ember mb-6">
            {eyebrow}
          </p>
          <h2 className="font-display text-display-lg tracking-editorial leading-[0.95]">
            {title.split(" ").slice(0, -1).join(" ")}{" "}
            <span className="italic font-light text-char">
              {title.split(" ").slice(-1)}
            </span>
          </h2>
          <p className="mt-8 max-w-md text-sm md:text-base leading-relaxed text-char">
            {body}
          </p>
        </div>

        <div className="col-span-7 md:col-span-4">
          <Photo
            slug={venue?.slug}
            alt="Venue ambience"
            ratio="4/5"
            caption="Catering · Spread"
            sizes="(min-width: 1024px) 30vw, 100vw"
          />
        </div>

        <div className="col-span-5 md:col-span-3 md:mt-12">
          <Photo
            slug={detail?.slug}
            alt="Detail macro"
            ratio="1/1"
            caption="Detail · Saffron"
            sizes="(min-width: 1024px) 25vw, 100vw"
          />
        </div>
      </div>
    </section>
  );
};

export default PhotoShowcase;
